<template>
	<form @submit.prevent="submit">
		<div>
			<div class="info">
				<h3>Progress this campaign to round {{ nextRound }}?</h3>
				<p>
					This will reset all vote tallies and hide all submissions not listed
					below.
				</p>
			</div>
			<div class="inputs">
				<FieldCheckbox name="active" v-model="fields.disableSubmissions"
					>Disallow new submissions to this campaign</FieldCheckbox
				>
			</div>
			<button type="button" class="btn" @click="showModal">
				Start round {{ nextRound }}
			</button>
		</div>
		<!-- Confirmation modal -->
		<Modal v-if="showProgress" @close="showProgress = false">
			<div class="info group">
				<h2>Confirm progression to round {{ nextRound }}</h2>
				<p>
					The campaign <strong>{{ campaign.name }}</strong> will progress to
					<strong>round {{ nextRound }}</strong
					>.
				</p>
				<p>
					Vote tallies will be reset, and the following submissions will be
					moved to the next round for voting:
				</p>
				<div class="shortlist">
					<ul class="shortlist__list">
						<li
							v-for="item in submissions"
							:key="item.id"
							class="shortlist__list__item"
						>
							<strong>{{ item.title }}</strong
							><br /><span class="shortlist__list__item__info"
								>Submitted by {{ item.name }} on {{ item.date }}</span
							>
						</li>
					</ul>
				</div>
				<p v-if="disableSubmissions">
					Submitting to this campaign will be disabled, and can be
					re&#8209;enabled by editing the campaign.
				</p>
				<p v-else>New submissions to this campaign will still be allowed.</p>
			</div>
			<SubmitButton :label="submitLabel" v-bind="submitButton" />
		</Modal>
	</form>
</template>

<script>
import FieldCheckbox from '@/components/shared/FieldCheckbox'
import SubmitButton from '@/components/shared/SubmitButton'
import Modal from '@/components/admin/Modal'
import form from '@/mixins/form'

export default {
	name: 'ProgressCampaignForm',
	props: {
		campaign: {
			type: Object,
			default: () => ({ round: 0 })
		},
		submissions: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			showProgress: false
		}
	},
	computed: {
		round() {
			return this.campaign.round + 1
		},
		nextRound() {
			return this.round + 1
		},
		submitLabel() {
			return `Start round ${this.nextRound}`
		},
		disableSubmissions() {
			return this.fields.disableSubmissions.value
		}
	},
	methods: {
		showModal() {
			this.showProgress = true
		},
		hideModal() {
			this.showProgress = false
		}
	},
	mixins: [form.progressCampaign],
	components: {
		FieldCheckbox,
		SubmitButton,
		Modal
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/vars';
@import '~scss/layout';
@import '~scss/components';

.columns {
	row-gap: 1rem;
	column-gap: 1.5rem;
}

.info {
	@include truncate-margin;
	margin-bottom: 1.5rem;
}

.inputs {
	margin-bottom: 2rem;
}

.btn {
	@include button--large();
}

.shortlist {
	max-height: 50vh;
	overflow-y: auto;

	&__list {
		padding-left: 1.75rem;

		&__item {
			&:not(:last-child) {
				margin-bottom: 0.5rem;
			}

			&__info {
				font-size: 90%;
			}
		}
	}
}
</style>
